import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const uploadFiles = async (kind, id, token, files, setProgress) => {
  const headers = { "X-Upload-Token": token };
  let failed = 0;
  setProgress(files.map(() => 0));
  for (let i = 0; i < files.length; i += 1) {
    const body = new FormData();
    body.append("file", files[i]);
    try {
      await axios.post(`${API}/${kind}/${id}/files`, body, {
        headers,
        onUploadProgress: (ev) =>
          setProgress((p) => p.map((v, j) => (j === i ? Math.round((ev.loaded / (ev.total || 1)) * 100) : v))),
      });
    } catch {
      failed += 1;
    }
  }
  const done = await axios.post(`${API}/${kind}/${id}/complete`, {}, { headers }).then(() => true, () => false);
  return { failed, done };
};
